<template>
  <div class="autoResult none">
    <ul>
      <li v-if="autoSearchLoading">Loading...</li>
      <li
        v-for="(item, k) in autoProducts"
        v-bind:key="k"
        class="section-item p-2"
      >
        <a :href="`${baseUrl}book/${item.id}`">
          <div class="d-flex justify-content-start pr">
            <ProductImage :image="item.image" />
            <div>
              <ProductName :productName="item.product_name" />
              <div class="font-12">
                <AuthorName :authorNames="item.author" />
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import VueLoadImage from "vue-load-image";
import ProductName from './ProductName.vue';
import AuthorName from './AuthorName.vue';
import ProductImage from './ProductImage.vue';

export default {
  name: "AutoSearch",
  props: ["autoProducts", "currentPage", "autoSearchLoading"],
  components: {
    VueLoadImage,
    ProductName,
    AuthorName,
    ProductImage
  },
  mounted() {
    $(document).mouseup(function (e) {
      var container = $(".autoResult");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
      }
    });
  },
};
</script>
